import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    "&$disabled": {
      backgroundColor: theme.palette.common.white
    }
  },
  hideBg: {
    background: "transparent",
    "&$disabled": {
      backgroundColor: "transparent"
    }
  },
  hideShadow: {
    boxShadow: "none"
  },
  hideBorder: {
    border: "1px solid transparent",
    borderBottom: "1px solid transparent"
  },
  summary: {
    display: "flex",
    position: "relative",
    paddingLeft: 0,
    alignItems: "center",
    flexGrow: 1,
    "&$hideBorder": {
      border: "1px solid transparent",
      borderBottom: "1px solid transparent"
    }
  },
  summaryIcon: {
    padding: 0
  },
  summaryCount: {
    background: "rgba(238, 238, 238, 1)",
    padding: "9px 5px",
    color: theme.palette.text.primary,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    borderRadius: "3px 0 0 3px",
    minWidth: 25,
    textAlign: "center"
  },
  roundSummaryCount: {
    fontSize: 12,
    minHeight: 18,
    height: 18,
    width: 18,
    minWidth: 18,
    background: "#d5d5d5",
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%"
  },
  summaryCountAlert: {
    background: theme.palette.warning.dark,
    color: theme.palette.common.white
  },
  summaryTitle: {
    color: theme.palette.text.primary,
    paddingLeft: 10,
    flexGrow: 1
  },
  summarySubtitle: {
    color: theme.palette.text.secondary,
    fontSize: 14,
    paddingRight: 8,
    opacity: 1
  },
  hideSubtitle: {
    opacity: 0,
    transition: "opacity 300ms"
  },
  summaryExpanded: {
    "& $summaryCount": {
      borderRadius: "3px 0 0 0"
    },
    "& $roundSummaryCount": {
      borderRadius: "50%"
    }
  },
  details: {
    padding: 0
  },
  isLoading: {
    "& $roundSummaryCount": {
      background: "transparent"
    }
  },
  loader: {
    padding: 0,
    width: "auto"
  },
  disabled: {
    "& $summary": {
      opacity: 1
    },
    "& $summaryIcon": {
      display: "none"
    }
  }
}));
